import leadService from "../../services/leadService";
import haugazelService from "../../services/haugazelService";
import moment from "moment";

const getDefaultState = () => {
  return {
    civility: null,
    firstName: null,
    lastName: null,
    civilities: [],
    phone: "",
    mail: "",
    isPro: false,
    consent: 0,
    contactIsChanged: false,
    contactFormFilledOnce: false,
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setCivility(state, value) {
      state.civility = value;
    },
    setFirstName(state, value) {
      state.firstName = value;
    },
    setLastName(state, value) {
      state.lastName = value;
    },
    setPhone(state, value) {
      state.phone = value;
    },
    setMail(state, value) {
      state.mail = value;
    },
    setIsPro(state, value) {
      state.isPro = value;
    },
    setConsent(state, value) {
      state.consent = value;
    },
    setCivilities(state, value) {
      state.civilities = value;
    },
    setContactIsChanged(state, value) {
      state.contactIsChanged = value;
    },
    setContactFormFilledOnce(state, value) {
      state.contactFormFilledOnce = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    urlDecode(
      commit,
      {
        civility: civility,
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        mail: mail,
        isPro: isPro
      }
    ) {
      commit.setCivility(civility);
      commit.setFirstName(firstName);
      commit.setLastName(lastName);
      commit.setPhone(phone);
      commit.setMail(mail);
      commit.setIsPro(isPro);
    },
    async getCivilities(context, locale) {
      let civilities = [];
      let response = await haugazelService.getCivilities();

      response.forEach(civility => {
        civilities.push(civility[locale]);
      });

      context.commit("setCivilities", civilities);
    },
    async save(context) {
      let leadData = {
        uuid: context.rootState.common.uuid,
        checkDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        prospectType: context.state.isPro ? "pro" : "resi"
      };

      let isMobile = null;
      let number = null;

      if(context.state.phone && context.state.phone.length > 0) {
        isMobile = context.state.phone.match("^((\\+|00|)32\\s?|0|)4(5[56]|60|[6789]\\d)(\\s?\\d{2}){3}$");
        number = context.state.phone;

        if (number && number.substring(0, 2) === "00") {
          number = `+${number.substring(2)}`;
        }
      }

      try {
        await leadService.save(leadData);
      } catch (error) {
        throw error;
      }

      if (context.state.mail || context.state.phone) {
        let data = {
          uuid: context.rootState.common.uuid,
          type: context.state.isPro ? "pro" : "resi",
          civility: context.state.civility,
          firstName: context.state.firstName,
          lastName: context.state.lastName,
          zipCode: context.rootState.calculation.zipCode,
          phone: context.state.phone && number != null && !isMobile ? number : null,
          mobile: context.state.phone && number != null && isMobile ? number : null,
          email: context.state.mail,
          optin: context.state.consent
        };

        try {
          await leadService.saveProspect(data);
        } catch (error) {
          throw error;
        }
      }
    }
  },
  getters: {
    urlMapper: state => {
      return {
        civility: state.civility,
        firstName: state.firstName,
        lastName: state.lastName,
        phone: state.phone,
        mail: state.mail,
        isPro: state.isPro
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/contact.js